import React from 'react';
import { Slider } from 'antd';

export interface IBaseSliderProps {
  width?: string | number;
  height?: string | number;
  className?: string;
  value: number;
  onChange: (value: number) => void;
  min?: number;
  max?: number;
  step?: number;
}

const BaseSlider: React.FC<IBaseSliderProps> = (props) => {
  const { width, height, className, value, onChange, min, max, step } = props;

  return (
    <Slider
      className={className}
      style={{ width, height, margin: 3 }}
      min={min}
      max={max}
      step={step}
      value={value}
      onChange={onChange}
      tooltip={{ open: false }}
    />
  );
};

export default BaseSlider;
